import { isTouchDevice } from "../utils/helpers";

(function() {
  document.querySelectorAll(".carousel-container").forEach(container => {
    const ele = container.querySelector(".promotional-slider");
    const pauseButton = container.querySelector(".carousel-pause-btn");
    const pauseIcon = pauseButton.querySelector(".fa-pause");
    const playIcon = pauseButton.querySelector(".fa-play");
    const breakpoints = [];
    let gliderInstance;
    let autoRotateInterval;
    let isPaused = false; 

    function startAutoRotate() {
      autoRotateInterval = setInterval(() => {
        gliderInstance.scrollItem('next');
      }, 15000); // Change slide every 15 seconds
    }

    function stopAutoRotate() {
      clearInterval(autoRotateInterval);
    }

    window.addEventListener("load", () => {
      // Glider is present earlier in the DOM since it's a dependency.
      // eslint-disable-next-line
      gliderInstance = new Glider(ele, {
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: isTouchDevice(),
        rewind: true,
        dots: ele.parentNode.querySelector(".carousel__pagination"),
        responsive: breakpoints,
        arrows: {
          prev: ele.parentNode.querySelector(".glider-prev"),
          next: ele.parentNode.querySelector(".glider-next")
        }
      });

      // Start auto-rotate
      startAutoRotate();
    });

    pauseButton.addEventListener("click", () => {
      if (isPaused) {
        startAutoRotate();
        pauseIcon.style.display = "inline";
        playIcon.style.display = "none";
      } else {
        stopAutoRotate();
        pauseIcon.style.display = "none";
        playIcon.style.display = "inline";
      }
      isPaused = !isPaused;
    });

    ele.addEventListener("mouseenter", () => {
      if (!isPaused) {
        stopAutoRotate();
      }
    });

    ele.addEventListener("mouseleave", () => {
      if (!isPaused) {
        startAutoRotate();
      }
    });

    /**
     * Reinstate active slide button into tab order.  Tabindex is set to -1 in
     * the twig template to prevent users from tabbing to "hidden" slides.
     * Adding visibility: hidden in css breaks visual flow on slide transition.
     */
    ele.addEventListener("glider-slide-visible", function(event) {
      const glider = Glider(this);
      const currentSlideIndex = event.detail.slide;

      glider.slides[currentSlideIndex]
        .querySelector(".btn")
        .removeAttribute("tabindex");
    });

    /**
     * Ensure tabindex is set to "-1" on hidden slides after being removed.
     */
    ele.addEventListener("glider-slide-hidden", function(event) {
      const glider = Glider(this);
      const currentSlideIndex = event.detail.slide;

      glider.slides[currentSlideIndex]
        .querySelector(".btn")
        .setAttribute("tabindex", "-1");
    });
  });
})();
